<template>
  <div id="container">
    <div class="box">

      <div class="box_one" style="margin-bottom:5px">
        <cont-one/>
      </div>

      <div class="box_one" style="margin-bottom:5px">
        <cont-two/>
      </div>

      <div class="box_one" style="margin-bottom:5px">
        <cont-three/>
      </div>

      <div class="box_one" style="margin-bottom:5px">
        <cont-four/>
      </div>

      <div class="box_one" style="margin-bottom:5px">
        <cont-five/>
      </div>

      <div class="box_one" style="margin-bottom:5px">
        <cont-six/>
      </div>

      <div class="box_one" >
        <cont-seven/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import ContOne from '@/'
import ContOne from '@/views/HomeComponent/cont_one'
import ContTwo from '@/views/HomeComponent/cont_two'
import ContThree from '@/views/HomeComponent/cont_three'
import ContFour from '@/views/HomeComponent/cont_four'
import ContFive from '@/views/HomeComponent/cont_five'
import ContSix from '@/views/HomeComponent/cont_six'
import ContSeven from '@/views/Components/Cont_bottom'



export default {
  name: 'Home',
  components: {
    ContOne ,
    ContTwo ,
    ContThree  ,
    ContFour ,
    ContFive ,
    ContSix ,
    ContSeven
  },created() {

    const hasVisitedHome = sessionStorage.getItem('hasVisitedHome')
    if (!hasVisitedHome) {
      sessionStorage.setItem('hasVisitedHome', 'true')
      this.$router.push('/moment/newsActivities')

    }
  }
}
</script>

<style lang="stylus" scoped>
#container
  background-color : #000;
  overflow-x : hidden ;
  width: 100%;

.box
  width: 1003px;
  background-color #fff;
  margin 0 auto
  .box_one{

  }



</style>
